<div class="page-layout carded fullwidth">
  <div class="center">
    <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
      <span class="h1" [translate]="'VOLUMETRY.TITLE'"> Volumetry </span>

      <div class="page-buttons" fxHide.xs>
        <mat-slide-toggle
          labelPosition="before"
          matTooltip="{{ 'VOLUMETRY.AUTORELOAD_TIME' | translate }}"
          (change)="autoRefresh($event)"
          [checked]="false"
        >
          {{ 'VOLUMETRY.AUTORELOAD' | translate }}
        </mat-slide-toggle>

        <button
          mat-stroked-button
          matTooltip="{{ 'VOLUMETRY.RELOAD' | translate }}"
          (click)="reload()"
          [disabled]="isLoading"
        >
          <i class="angularjs-fuse-icon icon-reload small"></i>
        </button>

        <button
          *ngIf="isFilterOn"
          mat-stroked-button
          matTooltip="{{ 'VOLUMETRY.FILTERS.CLEAR' | translate }}"
          [disabled]="isLoading"
          (click)="clearFilters()"
        >
          <i class="angularjs-fuse-icon icon-filter-remove"></i>
        </button>
      </div>

      <div class="page-buttons" fxShow="false" fxShow.xs>
        <button mat-stroked-button>
          <mat-icon class="accent-500-fg">keyboard_arrow_down</mat-icon>
        </button>

        <mat-menu #menuDashboard>
          <button mat-menu-item fxLayout="row" fxLayoutAlign="start center" (click)="reload()">
            <i class="angularjs-fuse-icon icon-reload small mr-4"></i>
            <span [translate]="'VOLUMETRY.RELOAD'">Reload</span>
          </button>

          <button
            *ngIf="isFilterOn"
            mat-menu-item
            fxLayout="row"
            fxLayoutAlign="start center"
            (click)="clearFilters()"
            [disabled]="isLoading"
          >
            <i class="angularjs-fuse-icon icon-filter-remove small mr-4"></i>
            <span [translate]="'VOLUMETRY.FILTERS.CLEAR'">Clear filters</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <app-filter></app-filter>

    <div class="content">
      <div class="content__card">
        <div class="content__card__header">
          <span class="content__card__header__title">
            {{ 'VOLUMETRY.CHART.HIGHER_VOLUME_OF_MAINTENANCE_PER_SEGMENT.TITLE' | translate }}
          </span>
          <mat-icon
            class="content__card__header__info-icon"
            matTooltip="{{ 'VOLUMETRY.CHART.HIGHER_VOLUME_OF_MAINTENANCE_PER_SEGMENT.TOOLTIP' | translate }}"
            [matTooltipShowDelay]="500"
            matTooltipPosition="left"
          >
            info_outline
          </mat-icon>
        </div>
        <div class="content__card__content">
          <fc-horizontal-bar-chart
            [results]="charts.segments.items"
            [isLoading]="isLoading"
            [colors]="['#8D8D8D']"
            (select)="onSelectSegment($event)"
          ></fc-horizontal-bar-chart>
        </div>
      </div>
      <div class="content__card">
        <div class="content__card__header">
          <span class="content__card__header__title">
            {{ 'VOLUMETRY.CHART.HIGHER_VOLUME_OF_MAINTENANCE_BY_TYPE_OF_MAINTENANCE.TITLE' | translate }}
          </span>
          <mat-icon
            class="content__card__header__info-icon"
            matTooltip="{{ 'VOLUMETRY.CHART.HIGHER_VOLUME_OF_MAINTENANCE_BY_TYPE_OF_MAINTENANCE.TOOLTIP' | translate }}"
            [matTooltipShowDelay]="500"
            matTooltipPosition="left"
          >
            info_outline
          </mat-icon>
        </div>
        <div class="content__card__content">
          <fc-horizontal-bar-chart
            [results]="charts.types.items"
            [isLoading]="isLoading"
            [colors]="['#2A59B9']"
            (select)="onSelectMaintenanceType($event)"
          ></fc-horizontal-bar-chart>
        </div>
      </div>
      <div class="content__card">
        <div class="content__card__header">
          <div class="title-on-left">
            <mat-icon
              class="content__card__header__info-icon"
              matTooltip="{{ 'VOLUMETRY.CHART.AGE_OF_OPEN_MAINTENANCE.TOOLTIP' | translate }}"
              [matTooltipShowDelay]="500"
              matTooltipPosition="left"
            >
              info_outline
            </mat-icon>
            <div class="content__card__header__title">
              {{ 'VOLUMETRY.CHART.AGE_OF_OPEN_MAINTENANCE.TITLE' | translate }}
            </div>
            <span class="content__card__header__total">Total: {{ charts.pendingTimePerInterval.total }}</span>
          </div>
        </div>
        <div class="content__card__content">
          <vertical-bar-chart
            [results]="charts.pendingTimePerInterval.items"
            [isLoading]="isLoading"
            [showGridLines]="true"
            [rotateXAxisTicks]="false"
            [showDataLabel]="false"
            [yAxis]="true"
            [yAxisTickFormatting]="yAxisFormatToInteger"
            (select)="onSelectPendingTimePerInterval($event)"
            color="#52ADF4"
          ></vertical-bar-chart>
        </div>
      </div>
      <div class="content__card">
        <div class="content__card__header">
          <span class="content__card__header__title">
            {{ 'VOLUMETRY.CHART.MAINTENANCES_WITH_THE_LONGEST_OPEN_TIME.TITLE' | translate }}
          </span>
          <mat-icon
            class="content__card__header__info-icon"
            matTooltip="{{ 'VOLUMETRY.CHART.MAINTENANCES_WITH_THE_LONGEST_OPEN_TIME.TOOLTIP' | translate }}"
            [matTooltipShowDelay]="500"
            matTooltipPosition="left"
          >
            info_outline
          </mat-icon>
        </div>
        <div class="content__card__content">
          <fc-horizontal-bar-chart
            [results]="charts.topPendingTime.items"
            [isLoading]="isLoading"
            [colors]="['#E74B6A']"
            (select)="onSelectTopPendingPerInterval($event)"
          ></fc-horizontal-bar-chart>
        </div>
      </div>
      <div class="content__card">
        <div class="content__card__header">
          <span class="content__card__header__title">
            {{ 'VOLUMETRY.CHART.MAINTENANCE_COMPLETED_BY_APPLICATION.TITLE' | translate }}
          </span>
        </div>
        <div class="content__card__content">
          <pie-chart
            [results]="charts.maintenanceCompletedByApplication.items"
            [isLoading]="isLoading"
            [legendPosition]="'right'"
            [view]="[270, 270]"
          >
          </pie-chart>
        </div>
      </div>
      <div #containerRef class="content__card">
        <div class="content__card__header line-chart-header">
          <span class="content__card__header__title">
            {{ 'VOLUMETRY.CHART.COMPLETED_MAINTENANCE.TITLE' | translate }}
          </span>
          <div class="content__card__header__filter">
            <mat-icon
              class="content__card__header__filter__info-icon"
              matTooltip="{{ 'VOLUMETRY.CHART.COMPLETED_MAINTENANCE.TOOLTIP' | translate }}"
              [matTooltipShowDelay]="500"
              matTooltipPosition="left"
            >
              info_outline
            </mat-icon>
            <chart-date-interval-selector
              [dates]="
                filter.filterForm.valid
                  ? { from: filter.filterForm.value.openedAtGte, to: filter.filterForm.value.openedAtLte }
                  : null
              "
              (activeButtonEvent)="getDateLineChartDateInterval($event)"
            >
            </chart-date-interval-selector>
          </div>
        </div>
        <div class="content__card__content line-chart-section">
          <div *ngIf="!hasData">
            <p>{{ 'VOLUMETRY.CHART.COMPLETED_MAINTENANCE.NO_DATA' | translate }}</p>
          </div>
          <line-chart
            *ngIf="hasData && !isLoadingOnlyLineChart"
            [view]="[containerRef.offsetWidth - 64, 310]"
            (select)="onSelectMaintenanceCompletedTimeline($event)"
            [results]="maintenanceCompletedTimeline"
            [isLoading]="isLoading"
            [xAxis]="true"
            [yScaleMin]="0"
            [isDateFormat]="true"
          >
          </line-chart>
          <mat-spinner *ngIf="isLoadingOnlyLineChart" color="primary" diameter="64" class="mb-24"></mat-spinner>
        </div>
      </div>
    </div>
  </div>
</div>
